/* eslint-disable */
import React from 'react'
import {Icon, message} from 'antd'
import {Link} from 'react-router-dom'
import JASPERREPORT from '../BaseComponent/JASPERREPORT'
import http from '../Interceptor/Interseptor'
import SinglePicker from '../BaseComponent/singlePicker'
import {
  ExcelExport,
  grid,
  gridColumn,
  ExcelExportColumn,
  ExcelExportGroupHeader
} from '@progress/kendo-react-excel-export'
import jMoment from 'moment-jalaali'
import moment from 'moment'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import Select from 'react-select'
import Loader from '../loaders/loader'
jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true})

class NegativeSupplyOrder extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      fromDate: null,
      excel: [],
      toDate: null,
      excelOrderAggregated: [],
      excelOrderDetaild: []
    }
  }
  componentDidMount() {}

  changeFromDate = (fromDate) => {
    this.setState({fromDate, toDate: fromDate})
  }

  changeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  epochFrom = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/MM/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()

    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
    // return fromEpoch - (3.5 * 3600 * 1000);
  }
  epochTo = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/MM/D')
    let from = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(from).valueOf()

    if (n >= 0) {
      return toEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return toEpoch - 3.5 * 3600 * 1000
    } else {
      return toEpoch - 3.5 * 3600 * 1000
    }
    // return fromEpoch - (3.5 * 3600 * 1000);
  }

  submit(e) {
    e.preventDefault()
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  changeDeliveryBehavior = (deliveryBehaviour) => {
    this.setState({deliveryBehaviour})
  }
  changeDeliveryLocation = (deliveryLocation) => {
    this.setState({deliveryLocation})
  }

  supplyOrderDetailed() {
    let fromDate = this.state.fromDate
    let toDate = this.state.toDate
    if (fromDate === null || toDate === null) {
      message.error('هر دو تاریخ وارد شود')
    } else {
      JASPERREPORT(
        `report/jasper/supply-order-detailed/negative?fromTime=${this.epochFrom(fromDate)}&toTime=${this.epochTo(
          toDate
        )}`
      )
    }
  }
  excelSupplyOrderDetailed() {
    let fromDate = this.state.fromDate
    let toDate = this.state.toDate
    if (fromDate === null || toDate === null) {
      message.error('هر دو تاریخ وارد شود')
    } else {
      this.setState({
        loading: true
      })
      http
        .get(
          `report/json/supply-order-detailed/negative?fromTime=${this.epochFrom(fromDate)}&toTime=${this.epochTo(
            toDate
          )}`,
          {}
        )
        .then((res) => {
          this.setState({
            loading: false
          })
          if (res.data.error === null) {
            if (res.data.error === null) {
              this.setState(
                {
                  excelOrderDetaild:
                    res.data.object.supplyOrderDetailedViewList === null
                      ? []
                      : res.data.object.supplyOrderDetailedViewList
                },
                () => {
                  this.state.excelOrderDetaild.forEach((item) => {
                    item.provider = item.sellerName + ' - ' + item.sellerId
                  })
                  this._exportDetaild.save(this.state.excelOrderDetaild)
                }
              )
            }
          }
        })
        .catch((err) => {})
    }
  }

  getSupplyAggregated() {
    let fromDate = this.state.fromDate
    let toDate = this.state.toDate
    if (fromDate === null || toDate === null) {
      message.error('هر دو تاریخ وارد شود')
    } else {
      JASPERREPORT(
        `report/jasper/supply-order-aggregated/negative?fromTime=${this.epochFrom(fromDate)}&toTime=${this.epochTo(
          toDate
        )}`
      )
    }
  }

  excelSupplyAggregated() {
    let fromDate = this.state.fromDate
    let toDate = this.state.toDate
    if (fromDate === null || toDate === null) {
      message.error('هر دو تاریخ وارد شود')
    } else {
      this.setState({
        loading: true
      })
      http
        .get(
          `report/json/supply-order-aggregated/negative?fromTime=${this.epochFrom(fromDate)}&toTime=${this.epochTo(
            toDate
          )}`,
          {}
        )
        .then((res) => {
          this.setState({
            loading: false
          })
          if (res.data.error === null) {
            this.setState(
              {
                excelOrderAggregated:
                  res.data.object.supplyOrderAggregatedViewList === null
                    ? []
                    : res.data.object.supplyOrderAggregatedViewList
              },
              () => {
                this.state.excelOrderAggregated.forEach((item) => {
                  item.provider = item.sellerName + ' - ' + item.sellerId
                })
                this._exportAggregated.save(this.state.excelOrderAggregated)
              }
            )
          }
        })
        .catch((err) => {
          this.setState({
            loading: false
          })
        })
    }
  }

  fromDate(props) {
    return <input className="form-control" {...props} />
  }

  toDate(props) {
    return <input className="form-control" {...props} />
  }

  render() {
    const CustomGroupHeader = (props) => {
      return `Category: `
    }
    return (
      <div className="rtl">
        <Loader show={this.state.loading} />
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._exportDetaild = exporter
            }}
            fileName="گزارش ریز اقلام کسر شده از سفارش تامین.xls"
            style={{height: '420px'}}
            data={this.state.excelOrderDetaild}
          >
            <ExcelExportColumn
              key={'provider'}
              field={'provider'}
              title={'تامین کننده'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'productId'}
              field={'productId'}
              title={'کد کالا'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'productCode'}
              field={'productCode'}
              title={'بارکد'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'productTitle'}
              field={'productTitle'}
              title={'نام کالا'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'quantity'}
              field={'quantity'}
              title={'مقدار'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'unitName'}
              field={'unitName'}
              title={'واحد'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'supplyOrderId'}
              field={'supplyOrderId'}
              title={'شناسه سفارش تامین'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'orderId'}
              field={'orderId'}
              title={'شناسه سفارش'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'orderItemId'}
              field={'orderItemId'}
              title={'شناسه آیتم سفارش'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
          </ExcelExport>

          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._exportAggregated = exporter
            }}
            fileName="گزارش تجمیعی اقلام کسر شده از سفارش تامین.xls"
          >
            <ExcelExportColumn
              key={'provider'}
              field={'provider'}
              title={'تامین کننده'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'productId'}
              field={'productId'}
              title={'کد کالا'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'productCode'}
              field={'productCode'}
              title={'بارکد'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'productTitle'}
              field={'productTitle'}
              title={'نام کالا'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'quantitySum'}
              field={'quantitySum'}
              title={'مقدار'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'unitName'}
              field={'unitName'}
              title={'واحد'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
          </ExcelExport>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>سفارش تامین کنندگان</li>
            <li>گزارش اقلام کسر شده از سفارش تامین</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>گزارش اقلام کسر شده از سفارش تامین</p>
            </div>

            <div className="formComponent">
              <label className="font-weight-bold">
                تاریخ سفارش تامین از :<span className="requireFiled font-weight-bold">*</span>
              </label>
              <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                <DatePicker
                  inline
                  okLabel="تأیید"
                  autoOk={true}
                  leftArrowIcon={<Icon type="left" />}
                  rightArrowIcon={<Icon type="right" />}
                  cancelLabel="لغو"
                  labelFunc={(fromDate) => (fromDate == null ? '' : fromDate.format('jYYYY/jM/jDD'))}
                  value={this.state.fromDate}
                  id="date"
                  onChange={this.changeFromDate}
                  TextFieldComponent={this.fromDate}
                  readOnly
                />
              </MuiPickersUtilsProvider>
            </div>
            <div className="formComponent">
              <label className="font-weight-bold">
                تاریخ سفارش تامین تا :<span className="requireFiled font-weight-bold">*</span>
              </label>
              <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                <DatePicker
                  inline
                  okLabel="تأیید"
                  autoOk={true}
                  leftArrowIcon={<Icon type="left" />}
                  rightArrowIcon={<Icon type="right" />}
                  cancelLabel="لغو"
                  labelFunc={(toDate) => (toDate == null ? '' : toDate.format('jYYYY/jM/jDD'))}
                  value={this.state.toDate}
                  id="date"
                  onChange={this.changeToDate}
                  TextFieldComponent={this.toDate}
                  minDate={this.state.fromDate !== null ? this.state.fromDate : 0}
                  readOnly
                />
              </MuiPickersUtilsProvider>
            </div>

            <div className="formComponent">
              <button className="btn btn-info btn-block jasperBtn" onClick={this.supplyOrderDetailed.bind(this)}>
                گزارش ریز اقلام کسر شده از سفارش تامین
              </button>
              <button className="btn btn-info btn-block jasperBtn" onClick={this.excelSupplyOrderDetailed.bind(this)}>
                خروجی اکسل گزارش ریز اقلام کسر شده از سفارش تامین
              </button>
              <button className="btn btn-info btn-block jasperBtn" onClick={this.getSupplyAggregated.bind(this)}>
                گزارش تجمیعی اقلام کسر شده از سفارش تامین
              </button>
              <button className="btn btn-info btn-block jasperBtn" onClick={this.excelSupplyAggregated.bind(this)}>
                خروجی اکسل گزارش تجمیعی اقلام کسر شده از سفارش تامین
              </button>
              {/* <button className='btn btn-info btn-block jasperBtn' onClick={this.getReport2.bind(this)}>
                                2
                            </button> */}
              {/* <button className='btn btn-info btn-block jasperBtn' onClick={this.getExcel.bind(this)}>خروجی اکسل نقص وضعیت سفارش
                            </button> */}
              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default NegativeSupplyOrder
